"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTemplate = createTemplate;
exports.getTempLists = getTempLists;
exports.saveTemplateSettings = saveTemplateSettings;
exports.sendOrderMsg = sendOrderMsg;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 列表
 */
function getTempLists() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/templates',
  //     method: 'GET',
  //     params: pram,
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/message/web/message-template/page',
    method: 'GET',
    params: pram
  });
}

/**
 * 创建默认小程序模板关系
 */
function createTemplate() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/createTemplate',
  //     method: 'post',
  //     params
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/message/web/message-template/create-template',
    method: 'post',
    params: params
  });
}

/**
 * 保存模板设置
 */
function saveTemplateSettings() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // return request({
  //     url: '/admin/saveTemplateSettings',
  //     method: 'post',
  //     data
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/message/web/message-template/save-settings',
    method: 'post',
    data: data
  });
}

/**
 *发送消息
 */
function sendOrderMsg() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/send-notification',
    method: 'post',
    params: params
  });
}